import React from 'react';

export default function CancellationRefundModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center overflow-y-auto px-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl p-6 max-h-[80vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-6">Cancellation & Refund Policy</h2>
        <div className="text-gray-700 space-y-6 text-sm leading-relaxed pr-2">

          <section>
            <h3 className="font-semibold text-base mb-1">1. One-Time Payment</h3>
            <p>
              Poppyruz Premium is offered as a one-time, non-recurring payment. Once the payment is completed, you receive lifetime access to all premium features.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">2. Cancellations</h3>
            <p>
              Since our premium plan is not subscription-based and doesn’t recur automatically, there is no need for cancellation. You are not billed again.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">3. Refunds</h3>
            <p>
              We understand that things don’t always go as planned. If you experience technical issues or genuine problems accessing your premium features, we’re here to help.
            </p>
            <p className="mt-2">
              Refunds are reviewed on a case-by-case basis. Please reach out within <strong>7 days</strong> of purchase with:
            </p>
            <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
              <li>Your payment confirmation or transaction ID</li>
              <li>The email associated with your Poppyruz account</li>
              <li>A short explanation of the issue you faced</li>
            </ul>
            <p className="mt-2">
              Approved refunds will be processed back to the original payment method.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">4. Contact</h3>
            <p>
              For any questions regarding refunds, email us at{' '}
              <a href="mailto:support@poppyruz.com" className="text-blue-600 underline">
                mohamedzindha21@gmail.com
              </a>
              . We usually respond within 24 hours.
            </p>
          </section>
        </div>

        <div className="text-right mt-6">
          <button
            onClick={onClose}
            className="text-sm text-gray-600 hover:underline"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
